import { useNavigate } from 'react-router-dom';
import CartPanel from '../components/CartPanel';
import { useAppContext } from '../context/AppContext';
import { ROUTES } from '../navigation';

function CartPage() {
  const navigate = useNavigate();
  const {
    cart,
    currentUser,
    userAddresses,
    handleUpdateQuantity,
    handleRemoveFromCart,
    handleClearCart,
    handleAuthReady,
    setTrackingOrderId,
  } = useAppContext();

  return (
    <CartPanel
      cart={cart}
      onUpdateQuantity={handleUpdateQuantity}
      onRemove={handleRemoveFromCart}
      onClose={() => navigate(ROUTES.HOME)}
      onClearCart={handleClearCart}
      user={currentUser}
      addresses={userAddresses}
      onAuthReady={handleAuthReady}
      onOpenAddresses={() => navigate(ROUTES.ADDRESSES)}
      onOrderSuccess={(orderId) => {
        setTrackingOrderId(orderId);
        navigate(`/account/orders/${orderId}`);
      }}
    />
  );
}

export default CartPage;
